import type { AudioVideoValue } from '@interfaces/chime';
import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { useMeetingManager } from '../../providers/MeetingProvider';

export const AudioVideoContext = createContext<AudioVideoValue>(null);

export const AudioVideoProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const meetingManager = useMeetingManager();
  const [audioVideo, setAudioVideo] = useState<AudioVideoValue>(null);

  useEffect(() => {
    function audioVideoUpdateCb(av: AudioVideoValue) {
      setAudioVideo(av);
    }

    meetingManager.subscribeToAudioVideo(audioVideoUpdateCb);

    return () => meetingManager.unsubscribeFromAudioVideo(audioVideoUpdateCb);
  }, []);

  return (
    <AudioVideoContext.Provider value={audioVideo}>
      {children}
    </AudioVideoContext.Provider>
  );
};

export const useAudioVideo = (): AudioVideoValue => {
  const audioVideo = useContext(AudioVideoContext);

  return audioVideo;
};
